import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterBar = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  propertyOptions, 
  contractorOptions, 
  tradeOptions 
}) => {
  return (
    <div className="bg-surface rounded-lg border border-border p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-accent)" />
          <h3 className="text-base md:text-lg font-semibold text-foreground font-heading">Filters</h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear All
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        <Input
          type="search"
          placeholder="Search jobs..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          placeholder="All Properties"
          options={propertyOptions}
          value={filters?.property}
          onChange={(value) => onFilterChange('property', value)}
          clearable
        />

        <Select
          placeholder="All Contractors"
          options={contractorOptions}
          value={filters?.contractor}
          onChange={(value) => onFilterChange('contractor', value)}
          clearable
        />

        <Select
          placeholder="All Trades"
          options={tradeOptions}
          value={filters?.trade}
          onChange={(value) => onFilterChange('trade', value)}
          clearable
        />

        <Select
          placeholder="All Priorities"
          options={[
            { value: 'urgent', label: 'Urgent' },
            { value: 'high', label: 'High' },
            { value: 'medium', label: 'Medium' },
            { value: 'low', label: 'Low' }
          ]}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
          clearable
        />

        <Input
          type="date"
          placeholder="From Date"
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          type="date"
          placeholder="To Date"
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            fullWidth
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;